import { CommanderThunkAction } from '@mews-commander/types';
import { ReservationExtent } from '@mews-commander/data-access';
import { notEmpty } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import {
    fetchCurrentEnterpriseReservationsByGroupIds,
    fetchCurrentEnterpriseReservationsByReservationIds,
} from '@mews-commander/legacy-entities/src/actions/reservations';
import { fetchCardsByAccountIds } from '@mews-commander/legacy-entities/src/actions/paymentCards';
import { fetchKeyCutters } from '@mews-commander/legacy-entities/src/actions/keyCutters';
import { getCurrentEnterpriseReservationTimeState } from '@mews-commander/legacy-entities/src/selectors/reservations';
import { fetchLoyaltiesByAccountIds } from '@mews-commander/legacy-entities/src/actions/loyalties';
import { fetchAccountNotesByAccountIds } from '@mews-commander/legacy-entities/src/actions/accountNotes';
import { balanceLoadTimeState } from '../reservationModule/components/SmartDetail/Balances/constants';
import { fetchCustomerBalances } from '../reservationModule/ducks/balances';

const RESERVATION_DATA_EXTENT: ReservationExtent = {
    reservationGroups: true,
    generalNotes: true,
    channelManagerNotes: true,
    accounts: true,
    companionships: true,
    businessSegments: true,
    availabilityBlocks: true,
    rates: true,
    partnerCompanies: true,
    vouchers: true,
    travelAgencies: true,
    orderItems: true,
    products: true,
    origin: true,
    bookingEngines: false,
    specialRequestNotes: false,
    purchaseOrderNumbers: false,
};

export const fetchReservationData =
    (reservationId: string): CommanderThunkAction =>
    async (dispatch, getState) => {
        const enterpriseId = getCurrentEnterpriseId();
        dispatch(fetchKeyCutters({ enterpriseId }));

        return dispatch(
            fetchCurrentEnterpriseReservationsByReservationIds({
                reservationIds: [reservationId],
                extent: {
                    ...RESERVATION_DATA_EXTENT,
                    purchaseOrderNumbers: true,
                },
            })
        ).then(async ({ value: { accounts } }) => {
            const accountIds = accounts?.map(({ id }) => id) || [];
            const state = getState();
            const reservationTimeState = getCurrentEnterpriseReservationTimeState(state, { id: reservationId });

            if (notEmpty(accountIds)) {
                return Promise.all([
                    dispatch(fetchCardsByAccountIds({ accountIds })),
                    dispatch(fetchLoyaltiesByAccountIds({ accountIds, extent: { programs: true, tiers: true } })),
                    dispatch(fetchAccountNotesByAccountIds({ accountIds })),
                    reservationTimeState !== undefined &&
                        balanceLoadTimeState.includes(reservationTimeState) &&
                        dispatch(fetchCustomerBalances(accountIds, enterpriseId)),
                ]);
            }
        });
    };

export const fetchReservationGroupData = (groupId: $TSFixMe) => (dispatch: $TSFixMe) =>
    dispatch(
        fetchCurrentEnterpriseReservationsByGroupIds({
            groupIds: [groupId],
            extent: { reservationGroups: true, origin: true, accounts: true },
        })
    );
